import { AnalysisReportRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function ReportsIndexRoute() {
  const { workspaceId } = Route.useParams();
  return <AnalysisReportRoute segment="reports" workspaceId={workspaceId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/reports/')({
  component: ReportsIndexRoute,
});
